/* @generated */

// ../src/global_header/global_header.ts
import "focus-visible";

// ../src/global_header/local_nav.tsx
import * as React2 from "react";
import { Link, Text } from "@dropbox/dig-components/typography";
import { IconButton } from "@dropbox/dig-components/buttons";
import { ListViewLine } from "@dropbox/dig-icons/assets";
import { UIIcon } from "@dropbox/dig-icons";

// ../src/utils.ts
import * as React from "react";
var weakInvariant = (condition, message) => {
  if (!condition) {
    console.error(`dig-components:`, message);
  }
};

// ../src/global_header/local_nav.tsx
var LocalNavLink = ({ children, ...rest }) => /* @__PURE__ */ React2.createElement(Text, { size: "medium" }, /* @__PURE__ */ React2.createElement(Link, { ...rest, hasNoUnderline: true, inverse: true, className: "dig-GlobalHeader-Local-Nav__link" }, children));
var LocalNavigation = ({ children, ariaLabel, mobileTriggerProps }) => {
  weakInvariant(
    React2.Children.toArray(children).length <= 3,
    "Local navigation should only be used with 3 links maximum."
  );
  return /* @__PURE__ */ React2.createElement("nav", { className: "dig-GlobalHeader-Local-Nav" }, /* @__PURE__ */ React2.createElement("div", { className: "dig-GlobalHeader-Local-Nav__hamburger" }, /* @__PURE__ */ React2.createElement(IconButton, { ...mobileTriggerProps, variant: "transparent" }, /* @__PURE__ */ React2.createElement(UIIcon, { src: ListViewLine, "aria-label": ariaLabel }))), /* @__PURE__ */ React2.createElement("div", { className: "dig-GlobalHeader-Local-Nav__children" }, children));
};
LocalNavigation.displayName = "LocalNavigation";

// ../src/global_header/logo.tsx
import * as React3 from "react";
import cx from "classnames";
import { WordmarkLogo } from "@dropbox/dig-logos";
var Logo = ({ href, src, renderAccessory, ...rest }) => /* @__PURE__ */ React3.createElement(
  "a",
  {
    ...rest,
    href,
    className: cx("dig-GlobalHeader-Logo", {
      "dig-GlobalHeader-Logo--hasAccessory": !!renderAccessory
    })
  },
  /* @__PURE__ */ React3.createElement(WordmarkLogo, { size: 32, src, role: "presentation" }),
  renderAccessory && renderAccessory
);
Logo.displayName = "Logo";

// ../src/global_header/notification_menu/notification_menu.tsx
import cx2 from "classnames";
import * as React8 from "react";
import { NotificationBadge } from "@dropbox/dig-components/badges";

// ../src/global_header/notification_menu/empty.tsx
import * as React4 from "react";
import { Menu } from "@dropbox/dig-components/menu";
var Empty = ({ emptyMessage }) => {
  return /* @__PURE__ */ React4.createElement(Menu.Row, { interactive: false, withTitle: emptyMessage });
};
Empty.displayName = "NotificationEmpty";

// ../src/global_header/notification_menu/loading.tsx
import * as React5 from "react";
import { Menu as Menu2 } from "@dropbox/dig-components/menu";
import { Spinner } from "@dropbox/dig-components/progress_indicators";
var Loading = () => {
  return /* @__PURE__ */ React5.createElement(Menu2.Row, { interactive: false, preferComposition: true }, /* @__PURE__ */ React5.createElement("div", { className: "dig-GlobalHeader-Notification__loading-container" }, /* @__PURE__ */ React5.createElement(Spinner, null)));
};
Loading.displayName = "NotificationLoading";

// ../src/global_header/notification_menu/section.tsx
import * as React6 from "react";
import { Button } from "@dropbox/dig-components/buttons";
import { Menu as Menu3 } from "@dropbox/dig-components/menu";
import { Text as Text2 } from "@dropbox/dig-components/typography";
var Section = (props) => {
  const { title, actionButton, items, itemRenderFn } = props;
  if (!items || items.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React6.createElement(Menu3.Segment, null, /* @__PURE__ */ React6.createElement(Menu3.Row, { interactive: false, preferComposition: true }, /* @__PURE__ */ React6.createElement(Menu3.RowContent, null, /* @__PURE__ */ React6.createElement(Menu3.RowTitle, null, /* @__PURE__ */ React6.createElement(Text2, { isBold: true, size: "small" }, title))), actionButton && /* @__PURE__ */ React6.createElement(Menu3.RowAccessory, null, /* @__PURE__ */ React6.createElement(Button, { ...actionButton, variant: "transparent", size: "small" }, actionButton.title))), items.map(itemRenderFn));
};
Section.displayName = "NotificationSection";

// ../src/global_header/utility_action_menu.tsx
import "focus-visible";
import * as React7 from "react";
import { IconButton as IconButton2 } from "@dropbox/dig-components/buttons";
import { UIIcon as UIIcon2 } from "@dropbox/dig-icons";
import {
  Menu as Menu4
} from "@dropbox/dig-components/menu";
import { Tooltip } from "@dropbox/dig-components/tooltips";
var UtilityActionMenu = ({
  iconSrc,
  children,
  customTriggerContents,
  triggerProps,
  wrapperActionProps,
  menuContentProps,
  tooltipTitle,
  slideSubmenu = false
}) => {
  return /* @__PURE__ */ React7.createElement("div", { className: "dig-GlobalHeader-UtilityItem" }, /* @__PURE__ */ React7.createElement(Menu4.Wrapper, { ...wrapperActionProps, slideSubmenu }, ({ getTriggerProps, getContentProps, triggerRef }) => {
    const trigger = /* @__PURE__ */ React7.createElement(IconButton2, { variant: "transparent", ...getTriggerProps(triggerProps), size: "medium" }, !!iconSrc && /* @__PURE__ */ React7.createElement(UIIcon2, { src: iconSrc, size: "medium" }), !!customTriggerContents && customTriggerContents);
    return /* @__PURE__ */ React7.createElement(React7.Fragment, null, tooltipTitle ? /* @__PURE__ */ React7.createElement(Tooltip, { title: tooltipTitle, triggerRef }, trigger) : trigger, /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement(
      Menu4.Content,
      {
        ...getContentProps(),
        ...menuContentProps,
        placement: "bottom-end",
        positioningStrategy: "fixed"
      },
      children
    )));
  }));
};

// ../src/global_header/notification_menu/notification_menu.tsx
import { NotificationLine } from "@dropbox/dig-icons/assets";
import { Menu as Menu5 } from "@dropbox/dig-components/menu";
import { Text as Text3 } from "@dropbox/dig-components/typography";
var NotificationMenu = (props) => {
  const {
    hasNotifications,
    title,
    isLoading,
    emptyMessage,
    sections,
    onToggle,
    contentClassName,
    ...rest
  } = props;
  const isEmpty = !sections || sections.length === 0 || sections.every((s) => {
    return !s.items || s.items.length === 0;
  });
  return /* @__PURE__ */ React8.createElement(
    UtilityActionMenu,
    {
      ...rest,
      iconSrc: NotificationLine,
      wrapperActionProps: { onToggle },
      menuContentProps: { className: cx2("dig-GlobalHeader-Notification", contentClassName) },
      tooltipTitle: props.tooltipTitle,
      customTriggerContents: hasNotifications ? /* @__PURE__ */ React8.createElement(NotificationBadge, { className: "dig-GlobalHeader-NotificationBadge" }) : void 0
    },
    /* @__PURE__ */ React8.createElement(Menu5.Segment, { className: "dig-GlobalHeader-Notification__title" }, /* @__PURE__ */ React8.createElement(Menu5.Row, { interactive: false }, /* @__PURE__ */ React8.createElement(Text3, { isBold: true }, title))),
    /* @__PURE__ */ React8.createElement(Menu5.Segment, null, isLoading ? /* @__PURE__ */ React8.createElement(Loading, null) : isEmpty ? /* @__PURE__ */ React8.createElement(Empty, { emptyMessage }) : sections.map((s) => /* @__PURE__ */ React8.createElement(Section, { key: s.title, ...s })))
  );
};
NotificationMenu.displayName = "NotificationMenu";

// ../src/global_header/search.tsx
import * as React9 from "react";
import cx3 from "classnames";
import {
  TextInput
} from "@dropbox/dig-components/text_fields";
import { UIIcon as UIIcon3 } from "@dropbox/dig-icons";
import { SearchLine, CloseLine } from "@dropbox/dig-icons/assets";
import { IconButton as IconButton3 } from "@dropbox/dig-components/buttons";
var Search = ({
  ariaLabels,
  chips,
  containerProps,
  disabled,
  onSubmit,
  onContainerBlur,
  onContainerFocus,
  onCloseButtonClick,
  onCloseButtonKeyPress,
  inputProps,
  inputBoxRef,
  inputContainerRef,
  hasExpandableAnimation = false,
  isActive,
  isInvalid
}) => {
  const [isControlledComponent] = React9.useState(typeof isActive === "boolean");
  const [_isActive, setIsActive] = React9.useState(isControlledComponent ? isActive : false);
  const _handleFocus = () => {
    if (!isControlledComponent)
      setIsActive(true);
    if (onContainerFocus)
      onContainerFocus();
  };
  const _handleBlur = () => {
    if (!isControlledComponent)
      setIsActive(false);
    if (onContainerBlur)
      onContainerBlur();
  };
  const _handleSearchExit = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (inputBoxRef && inputBoxRef.current) {
      inputBoxRef.current.blur();
    }
    if (onCloseButtonClick)
      onCloseButtonClick();
  };
  const _handleCloseButtonKeyPress = (e) => {
    e.preventDefault();
    if (inputBoxRef && inputBoxRef.current) {
      inputBoxRef.current.blur();
    }
    if (onCloseButtonKeyPress)
      onCloseButtonKeyPress(e);
  };
  const _handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit();
    }
  };
  React9.useEffect(() => {
    if (isControlledComponent)
      setIsActive(isActive);
  }, [isActive, isControlledComponent]);
  const _inputProps = {
    ...inputProps,
    disabled: disabled || inputProps.disabled
  };
  return /* @__PURE__ */ React9.createElement(
    "div",
    {
      ...containerProps,
      className: cx3("dig-GlobalHeader-Search", {
        "dig-GlobalHeader-Search--active": _isActive,
        "dig-GlobalHeader-Search--expandable": hasExpandableAnimation
      }),
      onBlur: _handleBlur,
      onFocus: _handleFocus,
      "aria-expanded": _isActive
    },
    /* @__PURE__ */ React9.createElement("form", { onSubmit: _handleSubmit, key: "search__form", className: "dig-GlobalHeader-Search__form" }, /* @__PURE__ */ React9.createElement(
      TextInput.Container,
      {
        className: "dig-GlobalHeader-Search__container",
        disabled,
        isInvalid,
        ref: inputContainerRef
      },
      /* @__PURE__ */ React9.createElement(TextInput.Accessory, null, /* @__PURE__ */ React9.createElement(UIIcon3, { src: SearchLine })),
      !!chips && chips,
      /* @__PURE__ */ React9.createElement(
        TextInput.Input,
        {
          ..._inputProps,
          className: "dig-GlobalHeader-Search__input",
          ref: inputBoxRef,
          "aria-label": ariaLabels && ariaLabels.input
        }
      ),
      /* @__PURE__ */ React9.createElement(TextInput.Accessory, null, /* @__PURE__ */ React9.createElement(
        IconButton3,
        {
          variant: "transparent",
          onClick: _handleSearchExit,
          onKeyPress: _handleCloseButtonKeyPress,
          type: "button",
          size: "small",
          "aria-label": ariaLabels && ariaLabels.closeIcon,
          className: "dig-GlobalHeader-Search__exit-btn"
        },
        /* @__PURE__ */ React9.createElement(UIIcon3, { src: CloseLine })
      ))
    ))
  );
};
Search.displayName = "Search";

// ../src/global_header/utility_action_items.tsx
import * as React10 from "react";
import { HelpLine, NotificationLine as NotificationLine2 } from "@dropbox/dig-icons/assets";
import { Avatar } from "@dropbox/dig-components/avatar";
import { NotificationBadge as NotificationBadge2 } from "@dropbox/dig-components/badges";
var Notifications = ({
  children,
  hasNotifications,
  ...rest
}) => {
  return /* @__PURE__ */ React10.createElement(
    UtilityActionMenu,
    {
      ...rest,
      iconSrc: NotificationLine2,
      customTriggerContents: hasNotifications ? /* @__PURE__ */ React10.createElement(NotificationBadge2, { className: "dig-GlobalHeader-NotificationBadge" }) : void 0
    },
    children
  );
};
Notifications.displayName = "Notifications";
var Help = ({
  hasProductUpdates = false,
  children,
  tooltipTitle,
  ...rest
}) => {
  return /* @__PURE__ */ React10.createElement(
    UtilityActionMenu,
    {
      ...rest,
      iconSrc: HelpLine,
      tooltipTitle,
      customTriggerContents: hasProductUpdates ? /* @__PURE__ */ React10.createElement(NotificationBadge2, { className: "dig-GlobalHeader-NotificationBadge" }) : void 0,
      slideSubmenu: true
    },
    children
  );
};
Help.displayName = "Help";
var AccountMenu = ({
  children,
  initials,
  triggerProps,
  wrapperActionProps,
  menuContentProps,
  tooltipTitle,
  ...rest
}) => {
  return /* @__PURE__ */ React10.createElement(
    UtilityActionMenu,
    {
      triggerProps,
      wrapperActionProps,
      menuContentProps,
      tooltipTitle,
      customTriggerContents: /* @__PURE__ */ React10.createElement(Avatar, { ...rest, size: "small", hasNoOutline: true }, initials)
    },
    children
  );
};
AccountMenu.displayName = "AccountMenu";

// ../src/global_header/utility_nav.tsx
import * as React11 from "react";
var UtilityNav = ({ children }) => {
  return /* @__PURE__ */ React11.createElement("div", { className: "dig-GlobalHeader-UtilityNav" }, children);
};
UtilityNav.displayName = "UtilityNav";

// ../src/global_header/waffle/waffle.tsx
import * as React15 from "react";
import { Menu as Menu7 } from "@dropbox/dig-components/menu";

// ../src/global_header/waffle/group.tsx
import * as React14 from "react";

// ../src/global_header/waffle/row.tsx
import * as React13 from "react";
import cx4 from "classnames";
import { Menu as Menu6 } from "@dropbox/dig-components/menu";

// ../src/global_header/waffle/row_icon.tsx
import * as React12 from "react";
import * as Logos from "@dropbox/dig-logos";
import { GlyphLogo } from "@dropbox/dig-logos";
var RowIcon = ({ item }) => {
  if (item.iconTag) {
    const logo = Logos[`${item.iconTag}Glyph`];
    if (logo) {
      return /* @__PURE__ */ React12.createElement(GlyphLogo, { size: 40, src: logo, className: "dig-Waffle-row-logo" });
    } else {
      throw new Error(`Invalid iconTag ${item.iconTag}`);
    }
  } else {
    return /* @__PURE__ */ React12.createElement("img", { className: "dig-Waffle-row-logo", alt: "", src: item.icon });
  }
};
RowIcon.displayName = "RowIcon";

// ../src/global_header/waffle/row.tsx
import { AccessoryBadge } from "@dropbox/dig-components/badges";

// ../src/global_header/utils.ts
var generateGHLogName = (subComp, selectedItem) => {
  const modifier = selectedItem ? `select-${selectedItem}` : "trigger";
  return `gh_${subComp}_${modifier}`;
};

// ../src/global_header/waffle/row.tsx
var Row = ({ item, useHrefDirectly }) => {
  const title = /* @__PURE__ */ React13.createElement("div", { className: "dig-Waffle-row-title" }, item.title, item.badge && /* @__PURE__ */ React13.createElement(AccessoryBadge, { className: "dig-Waffle-row-branding" }, item.badge));
  const subtitle = /* @__PURE__ */ React13.createElement("div", { className: "dig-Waffle-row-subtitle" }, item.subtitle);
  return /* @__PURE__ */ React13.createElement(
    Menu6.ActionItem,
    {
      className: cx4("dig-Waffle-row-wrapper", item.className),
      value: item,
      withLeftAccessory: /* @__PURE__ */ React13.createElement(RowIcon, { item }),
      withSubtitle: subtitle,
      "data-uxa-log": generateGHLogName("waffle", item.id),
      tagName: "a",
      target: "_blank",
      href: useHrefDirectly ? item.href : void 0
    },
    title
  );
};
Row.displayName = "Row";

// ../src/global_header/waffle/group.tsx
import { Title } from "@dropbox/dig-components/typography";
var Group = ({ group, useHrefDirectly }) => {
  if (!group.items) {
    return null;
  }
  return /* @__PURE__ */ React14.createElement("div", { className: "dig-Waffle-group" }, group.title && /* @__PURE__ */ React14.createElement(Title, { size: "small", className: "dig-Waffle-group-title" }, group.title), group.items.map((item) => /* @__PURE__ */ React14.createElement(Row, { item, key: item.title, useHrefDirectly })));
};
Group.displayName = "Group";

// ../src/global_header/waffle/waffle.tsx
import { IconButton as IconButton4 } from "@dropbox/dig-components/buttons";
import { UIIcon as UIIcon4 } from "@dropbox/dig-icons";
import { GridViewDenseLine } from "@dropbox/dig-icons/assets";
import classnames from "classnames";
var Waffle = ({
  className,
  inverse,
  items,
  groups = [],
  open,
  onToggle,
  onSelection,
  hasMaxHeight,
  menuTriggerAriaLabel,
  closeOnSelection = false,
  experimentalUseOnlyWithBottomRow
}) => {
  const footerLinkRenderOptions = {
    getRowProps: () => ({
      className: "dig-Waffle-footer-link dig-Waffle-row-wrapper"
    })
  };
  const useHrefDirectly = !onSelection;
  return /* @__PURE__ */ React15.createElement(
    Menu7.Wrapper,
    {
      onToggle,
      onSelection,
      closeOnSelection,
      hasMaxHeight
    },
    ({ getTriggerProps, getContentProps }) => /* @__PURE__ */ React15.createElement(React15.Fragment, null, /* @__PURE__ */ React15.createElement("div", { className }, /* @__PURE__ */ React15.createElement("span", { className: "dig-Waffle-button-container" }, /* @__PURE__ */ React15.createElement(
      IconButton4,
      {
        ...getTriggerProps(),
        variant: "transparent",
        "data-uxa-log": generateGHLogName("waffle"),
        "data-testid": "digWaffleMenuTrigger",
        "aria-label": menuTriggerAriaLabel,
        inverse
      },
      /* @__PURE__ */ React15.createElement(UIIcon4, { src: GridViewDenseLine })
    ))), /* @__PURE__ */ React15.createElement(
      Menu7.Content,
      {
        ...getContentProps(),
        placement: "bottom-end",
        positioningStrategy: "fixed",
        ...typeof open !== "undefined" ? { open } : {}
      },
      /* @__PURE__ */ React15.createElement(
        "div",
        {
          className: classnames("dig-Waffle-menu-content", {
            "dig-Waffle-menu-content--has-footer": !!experimentalUseOnlyWithBottomRow
          })
        },
        items.length > 0 && /* @__PURE__ */ React15.createElement(Group, { group: { items }, useHrefDirectly }),
        groups.map((group, index) => /* @__PURE__ */ React15.createElement(Group, { group, key: index, useHrefDirectly })),
        experimentalUseOnlyWithBottomRow && /* @__PURE__ */ React15.createElement("div", { className: "dig-Waffle-group" }, experimentalUseOnlyWithBottomRow(footerLinkRenderOptions))
      )
    ))
  );
};
Waffle.displayName = "Waffle";

// ../src/global_header/wrapper.tsx
import * as React16 from "react";
import cx5 from "classnames";
var Wrapper = ({
  children,
  isSticky = true,
  isDietHeader,
  hasNoBottomBorder = false,
  shouldAlwaysShowLogo = false
}) => {
  const hasSearch = !shouldAlwaysShowLogo && !!React16.Children.toArray(children).find(
    (child) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      child.type.displayName === Search.displayName
    )
  );
  return /* @__PURE__ */ React16.createElement(
    "header",
    {
      className: cx5("dig-GlobalHeader", {
        "dig-GlobalHeader--isSticky": !!isSticky,
        "dig-GlobalHeader--isDietHeader": !!isDietHeader,
        "dig-GlobalHeader--hasSearch": hasSearch,
        "dig-GlobalHeader--hasNoBottomBorder": hasNoBottomBorder,
        "dig-GlobalHeader--shouldAlwaysShowLogo": shouldAlwaysShowLogo
      })
    },
    children
  );
};
Wrapper.displayName = "Wrapper";

// ../src/global_header/whats_new/whats_new.tsx
import * as React17 from "react";
import { NotificationBadge as NotificationBadge3, AccessoryBadge as AccessoryBadge2 } from "@dropbox/dig-components/badges";
import { ENTER_KEY, Menu as Menu8 } from "@dropbox/dig-components/menu";
import { Text as Text4 } from "@dropbox/dig-components/typography";
import {
  ChevronRightLine,
  OpenLine,
  ChevronDownLine,
  ChevronUpLine
} from "@dropbox/dig-icons/assets";
import { UIIcon as UIIcon5 } from "@dropbox/dig-icons";
var MAX_VISIBLE_UPDATES = 3;
var WhatsNewUpdateRow = React17.memo(
  ({ update: { linkHref, id, title, badgeLabel, dateLabel, buttonLabel, body } }) => {
    const contents = /* @__PURE__ */ React17.createElement(
      Menu8.LinkItem,
      {
        "data-uxa-log": generateGHLogName("whats-new", `learn-${id}`),
        href: linkHref,
        target: "_blank",
        className: "dig-GlobalHeader-WhatsNew__row",
        preferComposition: true
      },
      /* @__PURE__ */ React17.createElement(Menu8.RowContent, { className: "dig-GlobalHeader-WhatsNew__row-content" }, /* @__PURE__ */ React17.createElement("div", { className: "dig-GlobalHeader-WhatsNew__row-labels" }, badgeLabel && /* @__PURE__ */ React17.createElement(AccessoryBadge2, { className: "dig-GlobalHeader-WhatsNew__row-badge" }, badgeLabel), dateLabel && /* @__PURE__ */ React17.createElement(Text4, { size: "small", color: "subtle", className: "dig-GlobalHeader-WhatsNew__row-date" }, dateLabel)), /* @__PURE__ */ React17.createElement(Menu8.RowTitle, { className: "dig-GlobalHeader-WhatsNew__row-title" }, title), /* @__PURE__ */ React17.createElement(Text4, { className: "dig-GlobalHeader-WhatsNew__row-body", color: "subtle", tagName: "div" }, body), buttonLabel && /* @__PURE__ */ React17.createElement(Text4, { isBold: true, className: "dig-GlobalHeader-WhatsNew__row-button", size: "small" }, buttonLabel))
    );
    return /* @__PURE__ */ React17.createElement(Menu8.Segment, null, contents);
  }
);
var WhatsNew = React17.memo(
  ({
    heading,
    showAllLabel,
    showAllHref,
    onSubmenuOpened,
    updates = [],
    newUpdateCount = 0,
    badgeLabel,
    closeOnSelection = false
  }) => {
    const hasExternalUpdateLink = React17.useMemo(() => {
      return showAllLabel && showAllHref;
    }, [showAllLabel, showAllHref]);
    const isExpandable = React17.useMemo(() => {
      if (hasExternalUpdateLink) {
        return false;
      }
      return !!showAllLabel && updates.length > MAX_VISIBLE_UPDATES;
    }, [hasExternalUpdateLink, showAllLabel, updates.length]);
    const visibleUpdates = React17.useMemo(
      () => isExpandable ? updates.slice(0, MAX_VISIBLE_UPDATES) : updates,
      [isExpandable, updates]
    );
    const additionalUpdates = React17.useMemo(
      () => isExpandable ? updates.slice(MAX_VISIBLE_UPDATES) : [],
      [isExpandable, updates]
    );
    const [isExpanded, setIsExpanded] = React17.useState(false);
    const handleShowAllKeydown = React17.useCallback((e) => {
      if (e.key === ENTER_KEY) {
        e.stopPropagation();
      }
      return;
    }, []);
    const menuContent = /* @__PURE__ */ React17.createElement(React17.Fragment, null, visibleUpdates.map((update) => /* @__PURE__ */ React17.createElement(WhatsNewUpdateRow, { key: update.id, update })), isExpandable && /* @__PURE__ */ React17.createElement(Menu8.Segment, null, /* @__PURE__ */ React17.createElement(
      Menu8.Row,
      {
        interactive: true,
        tagName: "button",
        onKeyDown: handleShowAllKeydown,
        onClick: () => setIsExpanded(!isExpanded),
        className: "dig-GlobalHeader-WhatsNew__expand-button",
        withRightAccessory: /* @__PURE__ */ React17.createElement(UIIcon5, { src: isExpanded ? ChevronUpLine : ChevronDownLine, role: "presentation" })
      },
      /* @__PURE__ */ React17.createElement(Text4, { variant: "label", isBold: true }, showAllLabel)
    ), isExpanded && additionalUpdates.map((update) => /* @__PURE__ */ React17.createElement(WhatsNewUpdateRow, { key: update.id, update }))), hasExternalUpdateLink && /* @__PURE__ */ React17.createElement(Menu8.Segment, null, /* @__PURE__ */ React17.createElement(
      Menu8.LinkItem,
      {
        "data-uxa-log": generateGHLogName("whats-new", "all-updates"),
        target: "_blank",
        withLeftAccessory: /* @__PURE__ */ React17.createElement(UIIcon5, { src: OpenLine, role: "presentation" }),
        href: showAllHref
      },
      /* @__PURE__ */ React17.createElement(Text4, { variant: "label", isBold: true }, showAllLabel)
    )));
    return /* @__PURE__ */ React17.createElement(
      Menu8.Submenu,
      {
        contentClassName: "dig-GlobalHeader-WhatsNew__content",
        closeOnSelection,
        onSubmenuOpened,
        triggerProps: {
          // @ts-ignore - data attributes will properly be passed along to the trigger, but it's not defined in the type
          "data-uxa-log": generateGHLogName("whats-new")
        },
        withTriggerContent: heading,
        withRightAccessory: /* @__PURE__ */ React17.createElement(React17.Fragment, null, badgeLabel && newUpdateCount > 0 && /* @__PURE__ */ React17.createElement(NotificationBadge3, { "aria-label": badgeLabel }, newUpdateCount), /* @__PURE__ */ React17.createElement(UIIcon5, { src: ChevronRightLine, size: "small" }))
      },
      menuContent
    );
  }
);
WhatsNew.displayName = "WhatsNew";

// ../src/global_header/global_header.ts
var GlobalHeader = {
  Search,
  Logo,
  Wrapper,
  AccountMenu,
  Notifications,
  NotificationMenu,
  Help,
  UtilityNav,
  LocalNavigation,
  LocalNavLink,
  Waffle,
  WhatsNew
};
export {
  GlobalHeader,
  generateGHLogName
};
